import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "unexpected-event-show-registered-file" }
const _hoisted_2 = ["src"]

import { computed } from "vue";
import UnexpectedEventFileType from '@/types/UnexpectedEventFile'


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventShowRegisteredFile',
  props: {
    file: {}
  },
  setup(__props: any) {

const props = __props;

const originalFileName = computed(() => {
  return props.file.originalFileName
})

const fileExtension = computed(() => {
  const parts = originalFileName.value.split('.');
  return parts[parts.length - 1];
})


return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (fileExtension.value != 'pdf')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.file?.fileBlob ?? '',
          style: {"width":"100%"}
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createBlock(_component_v_file_input, {
          key: 1,
          disabled: true,
          label: originalFileName.value
        }, null, 8, ["label"]))
  ]))
}
}

})